export class HallResearchSw {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '2.2';
        this.numberOfVideoOutputs = 1;
        this.videoOutputs = Array(17).fill('1');
        this.power = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /FW/i,
                callback: (match) => {
                    this.socket.send(`FW${this.firmwareVersion}`);
                },
            },
            {
                name: 'setPower',
                regExp: /PW(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1' ? true : false;
                    if (this.power)
                        this.socket.send(`PW${this.power ? '1' : '0'}`);
                    // The product does not send a power acknowledgement when powering off.
                },
            },
            {
                name: 'getPower',
                regExp: /PW$/i,
                callback: (match) => {
                    this.socket.send(`PW${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'setRoute',
                regExp: /CO(\d+),(\d+)/i,
                callback: (match) => {
                    const videoOutputIndex = parseInt(match[1], 10);
                    this.videoOutputs[videoOutputIndex] = match[2];
                    this.socket.send(`CO${videoOutputIndex},${match[2]}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /CO(\d+)/i,
                callback: (match) => {
                    // Return the status for each video output.
                    for (let i = 1; i <= this.numberOfVideoOutputs; i++) {
                        this.socket.send(`CO${i},${this.videoOutputs[i]}`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Invalid Command!!`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.numberOfVideoOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
    }
}
HallResearchSw.emulatorType = 'socketEmulator';
HallResearchSw.key = '-LSti3Qq6rZRICq5sFI0';
